import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_layout/downtime')({
  component: DowntimePage,
});

export function DowntimePage() {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold">System Maintenance</h1>
        <p className="text-lg">
          We are currently undergoing scheduled maintenance.
          <br /> We will be back online shortly. Thank you for your patience.
        </p>
      </div>
    </div>
  );
} 